import AddIcon from '@mui/icons-material/Add'

import { useCallback, useEffect, useState } from "react"
import ReplyIcon from '@mui/icons-material/Reply'
import { Box, Switch } from "@mui/material"
import NoDataImg from '../../../assets/img/no-data.gif'
import Pagination from '@mui/material/Pagination'
import { v4 as uuidv4 } from 'uuid'
import { useDispatch, useSelector } from "react-redux"
import Utils from "../../constants/Utils"
import { showDangerToast, showToast } from "../../constants/toaster"
import { uplodateLoading } from "../../../redux/features/common/commonSlice"
import urls from "../../constants/apiurl"
import ApiCaller from "../../constants/ApiCaller"
import { useNavigate } from "react-router-dom"
import { AddAdvertismentType } from './AddAdvertismentType'


const label = { inputProps: { 'aria-label': 'Size switch demo' } }


export const AdvertismentTypeList = (props) => {

    const [addNewAdsType, setAddNewAdsType] = useState(false)
    const [typeFormData, setTypeFormData] = useState({
        "recordId": 6,
        "uuid": "",
        "isActive": true,
        "createdAt": "",
        "updatedAt": "",
        "deleted": false,
        "name": "",
        "linkEnable": true,
        "worldValue": "",
        "ownerId": null,
        "active": true
    })
    const dispatch = useDispatch();
    const userData = useSelector((state) => state?.userData);
    const router = useNavigate()

    const { formatDate } = Utils();
    const [callAPi, setCallAPi] = useState('')
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [pagerecord, setPagerecord] = useState({
        totalItems: 0,
        pageNumber: 1,
        pageSize: 10,
        totalPages: 1
    });
    const [sort_type, setSortType] = useState('createdAt');
    const [sort_order, setSortOrder] = useState(false);
    const [datalist, setDatalist] = useState([]);
    const [statusDropdownText, setStatusDropdownText] = useState('Select Status');
    const [searchText, setSearchText] = useState('')
    const [page, setPage] = useState(1);
    const LOADING_ENABLE = useSelector((state) => state?.loading);

    const userPermisiions = useSelector(state => state?.permission)
    let currentModulePermission;
    let viewPermission = true;
    let editPermission = true;
    let deletePermissionVal = true;
    let activePermission = true;

    useEffect(() => {
        getTypeList()
    }, [callAPi])


    const getTypeList = async () => {

        let startDateObject
        let endDateObject
        if (startDate?.toDate()) {
            let newDate = new Date(startDate?.toDate())
            // newDate.setDate(newDate.getDate() + 1)
            startDateObject = newDate
        }
        if (endDate?.toDate()) {
            let newDate = new Date(endDate?.toDate())
            // newDate.setDate(newDate.getDate() + 1)
            endDateObject = newDate
        }

        try {
            dispatch(uplodateLoading(true))
            let postJson = {
                searchText: searchText?.trim(),
                pageNumber: pagerecord?.pageNumber - 1 || 0,
                pageSize: pagerecord.pageSize || 10,
                shortingField: sort_type,
                asc: sort_order,
                bannerType: null,
                active:
                    statusDropdownText === 'Active'
                        ? true
                        : statusDropdownText === 'In Active'
                            ? false
                            : null,
                startDate: startDateObject !== null ? startDateObject : '',
                endDate: endDateObject !== null ? endDateObject : ''
            }
            let path = urls.advertismentTypeList
            let res = await ApiCaller.post(postJson, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(uplodateLoading(false))
                setDatalist(response?.data?.items)
                setPagerecord({
                    totalItems: response?.data?.totalItems,
                    totalPages: response?.data?.totalPages,
                    pageNumber: pagerecord?.pageNumber,
                    pageSize: 10
                })
            } else {
                dispatch(uplodateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(uplodateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    };

    const handleStatusChange = async (event, id) => {
        try {
            dispatch(uplodateLoading(true))
            let path = urls.changeTypeStatus + '/' + id
            let res = await ApiCaller.get({}, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(uplodateLoading(false))
                showToast(response?.message)
                getTypeList("", startDate, endDate)
            } else {
                dispatch(uplodateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(uplodateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    };

    const handleEditCity = (item) => {
        setAddNewAdsType(true)
        setTypeFormData({
            ...item,
            isState: false,
            parentId: item?.countryId
        })
    }


    const handleChange = (event, value) => {
        setPage(value)
        setPagerecord({
            totalItems: pagerecord?.totalItems,
            totalPages: pagerecord?.totalPages,
            pageNumber: value,
            pageSize: 10
        })
        setCallAPi(uuidv4())
    }

    const handleFilterClick = useCallback(() => {
        setPage(1)
        setPagerecord({
            ...pagerecord,
            pageNumber: 1
        })
        setCallAPi(uuidv4())
    }, [searchText, startDate, endDate, statusDropdownText])

    const handleSubmitAdsType = async () => {
        try {
            dispatch(uplodateLoading(true))
            let path = urls.addAdvertismentType
            typeFormData.id = typeFormData.uuid
            let res = await ApiCaller.post(
                typeFormData,
                path,
                userData?.access_token
            )
            const response = await res.response.json()
            console.log('res', response)
            if (response.status == 200) {
                dispatch(uplodateLoading(false))
                showToast(response?.message)
                getTypeList("", startDate, endDate)
                setAddNewAdsType(false)
            } else {
                dispatch(uplodateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(uplodateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }



    const handleResetFilter = () => {
        setStartDate(null)
        setEndDate(null)
        setStatusDropdownText('Select Status')
        setSearchText('')
        setPage(1)
        setPagerecord({
            ...pagerecord,
            pageNumber: 1
        })
        setCallAPi(uuidv4())
    };

    return <>
        <div className='row'>
            <div className='col-md-6 text-left'>
                <a
                    onClick={() => props?.handleShowAdertismentType()}
                    className='btn btn-sm btn-primary text-white'
                >
                    <ReplyIcon />
                    Back
                </a>
            </div>
        </div>
        <div className='card-header border-0'>
            <div className='row align-items-center text-left'>
                <div className="col-md-7" style={{ textAlign: 'right' }}>
                    <h4>Advertisment Type List</h4>
                </div>
                <div className="col-md-5" style={{ textAlign: 'right' }}>
                    <a
                        onClick={() => setAddNewAdsType(!addNewAdsType)}
                        className='btn btn-sm btn-primary text-white'
                    >
                        <AddIcon />
                        Add
                    </a>
                </div>
                {/* <div className='col-md-3'>
                    <InputGroup
                        className='mb-2'
                        style={{ borderRadius: '10px' }}
                    >
                        <Form.Control
                            placeholder='Search by City Name'
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            aria-label='Amount (to the nearest dollar)'
                        />
                    </InputGroup>
                </div>
                <div className='col-md-2'>
                    <Dropdown>
                        <Dropdown.Toggle
                            variant='success'
                            style={{
                                backgroundColor: 'white',
                                color: 'black',
                                border: '1px solid #cad1d7',
                                boxShadow: 'none',
                                transform: 'none'
                            }}
                            id='dropdown-basic'
                        >
                            {statusDropdownText}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item
                                onClick={() =>
                                    setStatusDropdownText('Select Status')
                                }
                            >
                                Select Status
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={() => setStatusDropdownText('Active')}
                            >
                                Active
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={() => setStatusDropdownText('In Active')}
                            >
                                In Active
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <div className='col-md-6 mb-3'>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer
                            components={['DatePicker', 'DatePicker']}
                        >
                            <DatePicker
                                disableFuture
                                className='custom-date'
                                label='From Date'
                                value={startDate}
                                onChange={(newValue) => setStartDate(newValue)}
                                maxDate={endDate}
                            />
                            <DatePicker
                                disableFuture
                                label='To Date'
                                value={endDate}
                                onChange={(newValue) => setEndDate(newValue)}
                                minDate={startDate}
                            />
                        </DemoContainer>
                    </LocalizationProvider>
                </div>
                <div className='col-md-3 mb-2'>
                    <Button
                        variant='contained'
                        className='custom-filter-btn'
                        onClick={handleFilterClick}
                    >
                        Filter
                    </Button>
                    <Button
                        variant='contained'
                        className='ml-2 custom-filter-btn'
                        onClick={handleResetFilter}
                    >
                        Reset
                    </Button>
                </div> */}
            </div>
        </div>
        <div className='table-responsive'>
            {datalist && datalist?.length > 0 ? (
                <>
                    <table className='table align-items-center table-flush'>
                        <thead className='thead-light'>
                            <tr>
                                <th scope='col'>S/No.</th>
                                <th scope='col'>Name</th>
                                <th scope='col'>Link Enable</th>
                                <th scope='col'>World Rate</th>
                                <th scope='col'>Created At</th>
                                <th scope='col'>Status</th>
                                {
                                    (editPermission || deletePermissionVal) &&
                                    <th scope='col' >Action</th>
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {datalist &&
                                datalist?.map((data, i) => {
                                    const startIndex = (pagerecord.pageNumber - 1) * pagerecord.pageSize;
                                    return (
                                        <>
                                            <tr key={i}>
                                                <td>{startIndex + i + 1}</td>
                                                <td>{data?.name}</td>
                                                <td>{data?.linkEnable ? 'Enable' : 'Disable'}</td>
                                                <td>{data?.worldValue}</td>
                                                <td>{formatDate(data?.createdAt)}</td>
                                                <td>
                                                    {userData.admin ? (
                                                        <Switch
                                                            {...label}
                                                            checked={data?.isActive}
                                                            onChange={(e) =>
                                                                handleStatusChange(e, data?.uuid)
                                                            }
                                                            size='small'
                                                        />
                                                    ) : viewPermission ? (
                                                        <Switch
                                                            {...label}
                                                            checked={data?.isActive}
                                                            disabled={!activePermission}
                                                            onChange={(e) =>
                                                                handleStatusChange(e, data?.uuid)
                                                            }
                                                            size='small'
                                                        />
                                                    ) : (
                                                        <></>
                                                    )}
                                                </td>
                                                <td className='text-right'>
                                                    <div className='dropdown'>
                                                        <a
                                                            className='btn btn-sm btn-icon-only text-light'
                                                            role='button'
                                                            data-toggle='dropdown'
                                                            aria-haspopup='true'
                                                            aria-expanded='false'
                                                        >
                                                            <i className='fas fa-ellipsis-v' />
                                                        </a>
                                                        <div
                                                            className='dropdown-menu dropdown-menu-right dropdown-menu-arrow'
                                                            x-placement='bottom-end'
                                                            style={{
                                                                position: 'absolute',
                                                                willChange: 'transform',
                                                                top: '0px',
                                                                left: '0px',
                                                                transform:
                                                                    'translate3d(32px, 32px, 0px)'
                                                            }}
                                                        >
                                                            {userData.admin ? (
                                                                <a
                                                                    className='dropdown-item cursor'
                                                                    onClick={() =>
                                                                        handleEditCity(data)
                                                                    }
                                                                >
                                                                    Edit
                                                                </a>
                                                            ) : editPermission ? (
                                                                <a
                                                                    className='dropdown-item cursor'
                                                                    onClick={() =>
                                                                        handleEditCity(data)
                                                                    }
                                                                >
                                                                    Edit
                                                                </a>
                                                            ) : (
                                                                <></>
                                                            )}
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </>
                                    )
                                })}
                        </tbody>
                    </table>
                </>
            ) : (
                <>
                    <div className='text-center'>
                        <img width={'25%'} src={NoDataImg}></img>
                        <br />
                        <label style={{ fontWeight: 'bold' }}>
                            {LOADING_ENABLE ? (
                                <>Loading Data.....</>
                            ) : (
                                <>No Data Found</>
                            )}
                        </label>
                    </div>
                </>
            )}
        </div>
        {datalist && datalist.length > 0 ? (
            <div className='card-footer py-4'>
                <Box display="flex" justifyContent="right" alignItems='center'>
                    <span>Total record: {pagerecord?.totalItems}</span>
                    <Pagination
                        className='custom-pagination-class'
                        count={pagerecord?.totalPages}
                        page={page}
                        onChange={handleChange}
                        color='secondary'
                    />
                </Box>
            </div>
        ) : (
            <></>
        )}

        <AddAdvertismentType
            show={addNewAdsType}
            typeFormData={typeFormData}
            setTypeFormData={setTypeFormData}
            onSubmit={() => handleSubmitAdsType()}
            onHide={() => setAddNewAdsType(false)}
        />
    </>
}